import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstLxf: [],
		lxf: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, lxf){
			state.lxf = lxf
			if (lxf)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.lxf = null
		},
		setParamsDataTable(state, payload){
			state.lstLxf = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, lxfcodigo){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Oryx/LogisticIntegration/Find/${lxfcodigo}`)
			.then(response => {
				let lxf = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", lxf)
				return lxf
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async findByType(store, lxftipo){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Oryx/LogisticIntegration/FindByType/${lxftipo}`)
			.then(response => {
				let lxf = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", lxf)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		save(store){
			if (store.state.lxf.lxfcodigo){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Oryx/LogisticIntegration/Insert", store.state.lxf )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/integracoes-logisticas")
				store.state.lxf = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store, text = "Salvando"){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text, indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Oryx/LogisticIntegration/Update", store.state.lxf )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/integracoes-logisticas")
				store.state.lxf = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Oryx/LogisticIntegration/Delete/${store.state.lxf.lxfcodigo}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/integracoes-logisticas")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Oryx/LogisticIntegration/FindList")
			.then(response => {
				let lstLxf = Utils.ValidateAxiosResponse(response.data);
				store.state.lstLxf = lstLxf
				store.state.hasNext = lstLxf.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstLxf = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Oryx/LogisticIntegration/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstLxf = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async generateToken(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Conectando com o integrador logístico", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Oryx/LogisticIntegration/GenerateToken", store.state.lxf )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
	}
}